<template>
    <a href="javascript:;" class="btn-sy" @click="handleClick">
        <slot>
            <!-- -名称-->
        </slot>
    </a>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        methods: {
            handleClick(evt) {
                this.$emit('click', evt);
            }
        }
    };
</script>

<style scoped>
    .btn-sy {
        color: #09c;
        font-size: 14px;
        padding: 2px 10px 2px 0px;
        height: 20px;
        line-height: 14px;
        text-shadow: none;
        border: none;
        text-decoration:none;
    }
</style>


// WEBPACK FOOTER //
// src/components/Button.vue